const reorderCityFacetGroups = () => {
  document.querySelectorAll('.city-sunglasses-facets #FacetsWrapperDesktop, .city-sunglasses-facets #FacetsWrapperMobile').forEach((wrapper) => {
    const filters = Array.from(wrapper.querySelectorAll(':scope > .js-filter'));
    if (filters.length < 2) return;

    const boundary = filters[filters.length - 1].nextSibling;
    filters
      .sort((a, b) => {
        const aOrder = Number(a.style.getPropertyValue('--city-filter-order')) || 50;
        const bOrder = Number(b.style.getPropertyValue('--city-filter-order')) || 50;
        return aOrder - bOrder;
      })
      .forEach((filter) => wrapper.insertBefore(filter, boundary));
  });
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    window.requestAnimationFrame(reorderCityFacetGroups);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    document
      .querySelectorAll('dry-eye-product-type-shortcuts')
      .forEach((shortcuts) => shortcuts.syncFromSearchParams(searchParams));
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderDryEyeProductTypeShortcuts(html);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderCityCollectionPanelHeader(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderDryEyeProductTypeShortcuts(html);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderCityCollectionPanelHeader(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderCityCollectionPanelHeader(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const freshHeader = parsedHTML.querySelector('.city-collection-panel-header');
    const currentHeader = document.querySelector('.city-collection-panel-header');

    if (freshHeader && currentHeader) {
      currentHeader.innerHTML = freshHeader.innerHTML;
    } else if (!freshHeader && currentHeader) {
      currentHeader.remove();
    } else if (freshHeader && !currentHeader) {
      const filters = document.getElementById('main-collection-filters');
      if (filters) filters.before(freshHeader);
    }
  }

  static renderDryEyeProductTypeShortcuts(html) {
    const freshShortcuts = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('dry-eye-product-type-shortcuts');
    const currentShortcuts = document.querySelector('dry-eye-product-type-shortcuts');

    if (!freshShortcuts || !currentShortcuts) return;

    currentShortcuts.innerHTML = freshShortcuts.innerHTML;
    currentShortcuts.dataset.filterParam = freshShortcuts.dataset.filterParam || '';
    currentShortcuts.syncFromSearchParams(window.location.search);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    reorderCityFacetGroups();

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.mobile-facets__active-filters', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const currentElement = document.querySelector(selector);
      if (currentElement) currentElement.innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    const currentView = new URLSearchParams(window.location.search).get('view');

    if (currentView && currentView.indexOf('per-page-') === 0 && !searchParams.has('view')) {
      searchParams.set('view', currentView);
    }

    searchParams.delete('page');

    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm' ||
            form.id === 'FacetSortMobileBarForm' ||
            form.id === 'FacetSortFormSunglasses'
          ) {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const searchParams = new URLSearchParams(url);
    const currentView = new URLSearchParams(window.location.search).get('view');

    if (currentView && currentView.indexOf('per-page-') === 0 && !searchParams.has('view')) {
      searchParams.set('view', currentView);
    }

    searchParams.delete('page');

    FacetFiltersForm.renderPage(searchParams.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
window.FacetFiltersForm = FacetFiltersForm;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class DryEyeProductTypeShortcuts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('click', this.onShortcutClick.bind(this));
    this.syncFromSearchParams(window.location.search);
  }

  onShortcutClick(event) {
    const shortcut = event.target.closest('a[data-filter-values]');
    if (!shortcut || !this.contains(shortcut) || !this.dataset.filterParam) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(this.dataset.filterParam);
    searchParams.delete('page');

    shortcut.dataset.filterValues
      .split('|')
      .filter(Boolean)
      .forEach((value) => searchParams.append(this.dataset.filterParam, value));

    FacetFiltersForm.renderPage(searchParams.toString(), null);
  }

  syncFromSearchParams(searchParamsValue) {
    if (!this.dataset.filterParam) return;
    const searchParams = new URLSearchParams(searchParamsValue);
    const selectedValues = searchParams.getAll(this.dataset.filterParam);

    this.querySelectorAll('a[data-filter-values]').forEach((shortcut) => {
      const shortcutValues = shortcut.dataset.filterValues.split('|').filter(Boolean);
      const isActive = shortcutValues.length
        ? shortcutValues.some((value) => selectedValues.includes(value))
        : selectedValues.length === 0;

      shortcut.classList.toggle('is-active', isActive);
      const shortcutSearchParams = new URLSearchParams(searchParams);
      shortcutSearchParams.delete(this.dataset.filterParam);
      shortcutSearchParams.delete('page');
      shortcutValues.forEach((value) => shortcutSearchParams.append(this.dataset.filterParam, value));
      const shortcutQuery = shortcutSearchParams.toString();
      shortcut.href = `${window.location.pathname}${shortcutQuery ? `?${shortcutQuery}` : ''}`;

      if (isActive) {
        shortcut.setAttribute('aria-current', 'true');
      } else {
        shortcut.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('dry-eye-product-type-shortcuts')) {
  customElements.define('dry-eye-product-type-shortcuts', DryEyeProductTypeShortcuts);
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

(() => {
  if (window.cityMobileFacetsScrollLockReady) return;
  window.cityMobileFacetsScrollLockReady = true;

  let lockedScrollY = 0;

  const drawerIsOpen = () =>
    Boolean(document.querySelector('.city-sunglasses-facets .mobile-facets__disclosure[open].menu-opening'));

  const lock = () => {
    if (document.body.classList.contains('city-mobile-facets-open')) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.cityMobileFacetsScrollY = String(lockedScrollY);
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.classList.add('city-mobile-facets-open');
  };

  const unlock = () => {
    if (!document.body.classList.contains('city-mobile-facets-open')) return;
    const scrollY = Number(document.body.dataset.cityMobileFacetsScrollY || lockedScrollY || 0);
    document.body.classList.remove('city-mobile-facets-open');
    document.body.style.top = '';
    delete document.body.dataset.cityMobileFacetsScrollY;
    window.scrollTo(0, scrollY);
  };

  const sync = () => {
    window.setTimeout(() => {
      drawerIsOpen() ? lock() : unlock();
    }, 120);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest(
          '.city-sunglasses-facets .mobile-facets__open-wrapper, .city-sunglasses-facets .mobile-facets__close, .city-sunglasses-facets .mobile-facets__footer .button'
        )
      ) {
        sync();
      }
    },
    true
  );

  document.addEventListener('keyup', (event) => {
    if (event.code && event.code.toUpperCase() === 'ESCAPE') sync();
  });

  window.addEventListener('pagehide', unlock);
})();

(() => {
  const refreshCachedSunglassesSections = async () => {
    if (window.citySunglassesCachedSectionRefreshReady || window.location.pathname !== '/collections/sunglasses') return;

    const staleGrid = document.querySelector('[id^="shopify-section-template"][id$="__product-grid"]');
    const staleReadmore = document.querySelector('[id^="shopify-section-template"][id$="__collection-readmore"]');
    const hasStaleSummary = document.body.innerText.includes('Translation missing: en.sections.collection_template.results_range');
    const hasStaleReadmore = staleReadmore && !document.querySelector('.city-collection-seo');

    if (!staleGrid && !staleReadmore) return;
    if (!hasStaleSummary && !hasStaleReadmore) return;

    window.citySunglassesCachedSectionRefreshReady = true;

    const staleSection = staleGrid || staleReadmore;
    const sectionPrefix = staleSection.id
      .replace(/^shopify-section-/, '')
      .replace(/__(product-grid|collection-readmore)$/, '');
    const params = new URLSearchParams(window.location.search);
    params.delete('section_id');
    params.set('sections', `${sectionPrefix}__product-grid-v3,${sectionPrefix}__collection-seo`);

    try {
      const response = await fetch(`${window.location.pathname}?${params.toString()}`);
      if (!response.ok) return;
      const sections = await response.json();
      const parser = new DOMParser();

      if (hasStaleSummary && staleGrid && sections[`${sectionPrefix}__product-grid-v3`]) {
        const html = parser.parseFromString(sections[`${sectionPrefix}__product-grid-v3`], 'text/html');
        const freshSummary = html.querySelector('.city-collection-panel-header__summary');
        const staleSummary = document.querySelector('.city-collection-panel-header__summary');
        if (freshSummary && staleSummary) staleSummary.textContent = freshSummary.textContent;
      }

      if (hasStaleReadmore && staleReadmore && sections[`${sectionPrefix}__collection-seo`]) {
        const html = parser.parseFromString(sections[`${sectionPrefix}__collection-seo`], 'text/html');
        const freshReadmore = html.querySelector('[id^="shopify-section-template"][id$="__collection-seo"]');
        if (freshReadmore) staleReadmore.replaceWith(freshReadmore);
      }
    } catch (error) {
      return;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCachedSunglassesSections, { once: true });
  } else {
    refreshCachedSunglassesSections();
  }
})();
